import React from "react";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
//scrolling back to top

// I18n
// Router
// MUI
import { Box, Grid, makeStyles } from "@material-ui/core";
// Components
import CustomPieChartWithHeader from "components/CustomPieChartWithHeader";
import StackBarWithoutYaxis from "components/StackBarWithoutYaxis";
import { pieChartColors } from "../../config/index";

const useStyles = makeStyles((theme) => ({
  errorContent: {
    paddingLeft: 35,
    [theme.breakpoints.down("md")]: {
      paddingLeft: 0,
    },
  },
  content: {
    padding: theme.spacing(3),
  },
  root: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  leftBtn: { textAlign: "left" },
}));

const ActivityByJobRole = (props) => {
  const { jobFamilyChart, chart } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <>
      {jobFamilyChart.length > 0 && chart.length > 0 ? (
        <Box sx={{ width: "100%" }}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6}>
              {jobFamilyChart && (
                <StackBarWithoutYaxis
                  isLegendRequired={false}
                  data={jobFamilyChart}
                  xAxisDataKey="Name"
                  barDataKey1="Transactional"
                  bar1Color="#1B75BC"
                  barDataKey2="Non-Transactional"
                  bar2Color="#00A88E"
                  barDataKey3="Project"
                  bar3Color="#6DCFF6"
                  barDataKey4="Building Moves"
                  bar4Color="#3C5772"
                  bar5Color="Leave"
                  barDataKey5="#58595B"
                  barDataKey6="Meal"
                  bar6Color="#58595B"
                  // Building Moves & Leaves
                />
              )}
            </Grid>
            <Grid item xs={6}>
              {chart && (
                <CustomPieChartWithHeader
                  isLegendRequired={true}
                  data={chart}
                  colors={pieChartColors}
                ></CustomPieChartWithHeader>
              )}
            </Grid>
          </Grid>
        </Box>
      ) : (
        <>
          <Box className={classes.full}>
            <Alert severity="info">{t("pgHome.errNoReportData2")}</Alert>
          </Box>
        </>
      )}
    </>
  );
};

ActivityByJobRole.propTypes = {
  jobFamilyChart: PropTypes.array,
  chart: PropTypes.array,
};

export default ActivityByJobRole;
